import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import DropdownMenu from 'ui/DropdownMenu';

const MTableSelectedActions = ({ selected, actionMenuItems }) => {
    return (
        <Grid container spacing={3} alignItems="center">
            <Grid item>
                <Typography color="inherit" variant="subtitle1">
                    {`${selected.length} selected`}
                </Typography>
            </Grid>
            <Grid item>
                <DropdownMenu name="Actions" menuItems={actionMenuItems} />
            </Grid>
        </Grid>
    );
};

export { MTableSelectedActions };
